/* eslint-disable no-return-assign */
/* eslint-disable spaced-comment */
/* eslint-disable max-classes-per-file */
/* eslint-disable no-var */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
import { LiteralObject } from 'viggo-sistemas-core-web';

export class ValidadorSettingsApplication {
  //PRECO_PACOTE
  valor_aquisicao = 0;
  valor_recorrencia = 0;
  papeis = [];

  constructor(public application_settings: LiteralObject) {
    const application_regras = application_settings['regras'] ?? {};
    const application_preco_pacote = application_settings['preco_pacote'] ?? {};

    //PACOTE CUSTOMIZADO
    this.valor_aquisicao = application_preco_pacote['valor_aquisicao'] ?? 0;
    this.valor_recorrencia = application_preco_pacote['valor_recorrencia'] ?? 0;
    this.papeis = this.getPrecoPacotePapeis(application_preco_pacote);
  }

  getPrecoPacotePapeis(settings) {
    var result = [];
    var papeis = settings['papeis'] ?? [];
    papeis.forEach(papel => {
      result.push({
        id: papel['id'] ?? '',
        nome: papel['nome'] ?? '',
        quantidade: papel['quantidade'] ?? 0,
        valor: papel['valor'] ?? 0
      });
    });
    return result;
  }

  getApplicationSettingsBody(application_settings) {
    return (application_settings = {
      regras: {},
      preco_pacote: {
        valor_aquisicao: this.valor_aquisicao,
        valor_recorrencia: this.valor_recorrencia,
        papeis: this.papeis
      }
    });
  }
}
